<template>
  <div class="design-back">
    <div class="banner" v-lazy:background-image="{ src: require('../designImg/banner2-2x.png'),
        loading: require('../designImg/banner-sheji.jpg')}">
      <div class="divContsBg"></div>
      <div class="conts">
        <slot name="navList"></slot>
        <div class="texts">
          <img class="first-img" src="../designImg/01.png" alt="" />
          <ul class="imglist">
            <li v-for="(item, index) in projectList" :key="index">
              <img :src="item.imgList" alt="" />
              <div>
                <span class="span-first">{{item.typeList}}</span>
                <span class="span-second">{{item.realList}}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    backGroundCom: {
      readonly: true,
      require: true,
      default: () => {}
    }
  },
  data () {
    return {
      menuDatas: [],
      projectList: [
        {"typeList": "八年", "realList": "的教学沉淀", imgList: require("../designImg/boshi2x.png")},
        {"typeList": "众多", "realList": "的出色项目", imgList: require("../designImg/xiangmu@2x.png")},
        {"typeList": "有趣", "realList": "的设计内容", imgList: require("../designImg/youqu2x.png")},
        {"typeList": "创新", "realList": "的教学模式", imgList: require("../designImg/chuangxin2x.png")}
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .design-back {
    padding: 0;
    margin: 0;
    background-color: #fff;
    min-width: 1200px;
    .banner {
      width: 100%;
      height: 510px;
      overflow: hidden;
      position: relative;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      .divContsBg {
        // background-color: black;
        position: absolute;
        width: 100%;
        height: 81px;
        top: 0;
        // opacity: 0.11;
      }
      .conts {
        width: 1200px;
        margin: 0 auto;
        position: relative;
        ul {
          display: flex;
          justify-content: space-around;
          // margin-top: 24px;
          .title-nav {
            height: 32px;
            border-radius: 20px;
            background-color: white;
            cursor: pointer;
            &:hover {
              color: #1286FF;
            }
            a {
              border-radius: 20px;
              line-height: 32px;
              width: 100%;
              padding: 7px 35px;
              box-sizing: border-box;
            }
          }
          .active {
            background: #1286FF;
            color: #f9f9f9 !important;
            a {
              color: #f9f9f9 !important;
            }
          }
        }
      }
      .texts {
        margin-top: 130px;
        .first-img {
          width: 837px;
          height: 55px;
        }
        .second-img {
          margin-top: 69px;
          width: 670px;
          height: 82px;
        }
        h1 {
          height: 69px;
          margin-left: 10px;
          font-size: 40px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 69px;
          padding-top: 80px;
          font-family: "Fontquan-qingkehuangyouti";
        }
        p {
          height: 71px;
          font-size: 20px;
          opacity: .8;
          color: #fff;
          line-height: 40px;
          padding-top: 10px;
          overflow: hidden;
          font-family: "Fontquan-qingkehuangyouti";
        }
        .imglist {
          width: 50%;
          margin-top: 80px;
          li {
            img {
              width: 44px;
              vertical-align: middle;
              display: inline-block;
              text-align:center;
            }
            div {
              margin-top: 10px;
              margin-left: -40px;
              .span-first {
                display: inline-block;
                color: #fff;
                // font-size: 30px;
                opacity: 0.8;
                font-size: 24px;
                // font-family: Fontquan-qingkehuangyouti;
                font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
                font-weight: 400;
                text-align: left;
                color: #e4ebef;
                line-height: 33px;
                letter-spacing: 0px;
              }
              .span-second {
                color: #fff;
                font-size:16px;
                opacity: 0.8;
                // font-family: Fontquan-qingkehuangyouti;
                font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
                font-weight: 400;
                text-align: left;
                color: #e4ebef;
                line-height: 33px;
                letter-spacing: 0px;
              }
            }
          }
        }
      }
    }
    
  }
</style>